<template>
  <v-layout row justify-center >
      <v-card style="width:1200px">
        <v-card-title class="indigo" style="height:50px;margin-top:0px;padding-top:0px">
          <span class="body-2 white--text">Bulk Updates</span>
        <v-spacer/>
    
          <v-btn  @click="submit" small class="white green--text"  flat >Apply Changes</v-btn>
          <v-icon @click="close"   medium class="white--text">fas fa-times-circle</v-icon>
        </v-card-title>
        <v-divider/>
        <v-card-text>
            <v-layout wrap>
               <v-flex  xs12 sm12 md12>
                <template v-for="item in selectedData.selectedIds">
                    <v-chip small class="indigo white--text" close>{{item.name}}</v-chip>
                </template>
               </v-flex>
               <v-flex xs12>  
                <v-divider/><br/>
               </v-flex>
               <v-flex xs12 >
                   <v-layout row wrap style="zoom:90%" >
                       <v-flex xs12 class="body-2 black--text" >
                            What do you want to do ?
                      </v-flex>
                     <v-flex xs2 >
                      
                    <v-switch color="blue"
                        v-model="flags.removeUser"
                        label="Remove User"
                    ></v-switch>
                     </v-flex>
                     <v-flex xs2>
                     
                    <v-switch color="blue"
                        v-model="flags.addUser"
                        label="Add User"
                    ></v-switch>
                     </v-flex>
                     <v-flex xs3>
                     
                    <v-switch color="blue"
                        v-model="flags.schedule"
                        label='Change Schedule'
                    ></v-switch>
                    
                     </v-flex>
                     <v-flex xs2>
                     <v-switch color="blue"
                        v-model="flags.active"
                        label="Active/Inactive"
                    ></v-switch>
                     </v-flex>
                     
                    </v-layout>
                   </v-flex>
              <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                      <v-flex xs4 md4 sm4 >
                       <v-card style="min-height:360px;">
                            <v-toolbar style="height:50px;padding:0px;margin:0px" class="blue white--text">
                           <v-toolbar-title style="height:30px;padding:0px;margin:0px" class="body-2 blue white--text">Remove user from Subscription
                               <v-icon small class="white--text text-xs-right" @click="flags.removeUser=!flags.removeUser">
                                   {{!flags.removeUser ? "fas fa-angle-down" : "fas fa-angle-up" }}
                                </v-icon>
                           </v-toolbar-title>
                            </v-toolbar>
                            <v-list v-if="flags.removeUser">
                                <template v-for="(item,key) in selectedData.emails">
                                    <v-list-tile class="body-2" style="height:30px">
                                    <v-list-tile-action>
                                    <v-switch color="blue"
                                    v-model="selectedData.emails[key]"
                                    ></v-switch>
                                    </v-list-tile-action>
                                    <v-list-tile-title class="body-1">{{key}}</v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-card>
                      </v-flex>
                      <v-flex xs8 md8 sm8 style="padding-left:10px">
                        <v-layout row wrap>     
                          <v-flex xs6 md6 sm6>
                            <v-card style="min-height:150px;">
                                <v-toolbar style="height:50px;padding:0px;margin:0px" class="blue white--text">
                                    <v-toolbar-title  @click="flags.addUser=!flags.addUser" style="height:30px;padding:0px;margin:0px" class="body-2 blue white--text">
                                        Add user to Subscription
                                        
                                <v-icon small class="white--text text-xs-right">
                                            {{!flags.addUser ? "fas fa-angle-down" : "fas fa-angle-up" }}
                                    </v-icon>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                <v-textarea v-if="flags.addUser"
                                name="input-7-1"
                                label="Email To"
                                v-model="emailString"
                                hint="Select Receipients"
                                rows=2
                                ></v-textarea>     
                                </v-card-text>
                            </v-card>
                           </v-flex>
                            
                            <v-flex xs6 md6 sm6 style="padding-left:10px">
                            
                                <v-card style="min-height:150px;">
                                    <v-toolbar style="height:50px;padding:0px;margin:0px" class="blue white--text">
                                        <v-toolbar-title  @click="flags.active=!flags.active" style="height:30px;padding:0px;margin:0px" class="body-2 blue white--text">
                                            Inactivate /Deactivate Reports                     
                                    <v-icon small class="white--text text-xs-right">
                                                {{!flags.active ? "fas fa-angle-down" : "fas fa-angle-up" }}
                                        </v-icon>
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text justify-center class="text-xs-center">
                                            <v-switch v-if="flags.active" color="blue"
                                                v-model="active"
                                                label="Active"
                                            ></v-switch>
                                        </v-card-text>
        
                                </v-card>

                        </v-flex>
                        <v-flex xs12 md12 sm12 >&nbsp;</v-flex>

                    <v-flex xs12 md12 sm12 >
                       <v-card style="min-height:180px;">
                            <v-toolbar style="height:50px;padding:0px;margin:0px" class="blue white--text">
                                <v-toolbar-title  @click="flags.schedule=!flags.schedule" style="height:30px;padding:0px;margin:0px" class="body-2 blue white--text">
                                    Modify Schedule
                                    
                               <v-icon small class="white--text text-xs-right">
                                          {{!flags.schedule ? "fas fa-angle-down" : "fas fa-angle-up" }}
                                   </v-icon>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap v-if="flags.schedule">
                                    <v-flex xs12 style="padding-top:0px;margin-top:0px">
                                        <v-layout row wrap style="zoom:90%">
                                <v-flex xs3>
                                    <v-switch color="blue"
                                        v-model="flags.next_date"
                                        label="Next Date"
                                    ></v-switch>
                                </v-flex>
                                
                                <v-flex xs3>
                                    <v-switch color="blue"
                                        v-model="flags.next_time"
                                        label="Time"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs3>
                                    <v-switch color="blue"
                                        v-model="flags.interval"
                                        label="Interval"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs3>
                                    <v-switch color="blue"
                                        v-model="flags.interval_type"
                                        label="Type"
                                    ></v-switch>
                                </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            
                   <v-flex xs3 md3>
                       <v-menu
                       v-if="flags.next_date"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="next_date_fmt"
                label="Next Date"
                prepend-icon="event"
                readonly
              />
              <v-date-picker v-model="next_date" @input="menu2 = false"></v-date-picker>
             
            </v-menu>
          
                     </v-flex>
                     <v-flex xs3 md3>
                     <v-menu
                     v-if="flags.next_time"
              :close-on-content-click="false"
              v-model="menu3"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
            <v-text-field
                slot="activator"
                v-model="next_time"
                label="Next Time"
                prepend-icon="event"
                
            />
      <v-time-picker
        v-model="next_time"
        class="mt-3"
        format="24hr"
        scrollable
       ></v-time-picker>
       </v-menu>
       </v-flex>
       
       <v-flex xs2 md2>

           <v-text-field
           v-if="flags.interval"
            v-model="schedule_interval"
            label="Interval"
            prepend-icon="event"
        />
        </v-flex>
        &nbsp;
           <v-flex  xs3 md3>
        
          <v-select
          v-if="flags.interval_type"
        class="style-input mr-2"
        label="Frequency"
        :items="scheduleTypes"
        v-model="schedule_type"
    >
    </v-select>
      
         </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                
                            </v-card-text>
                          
                   </v-card>

                   
              </v-flex>
              
                        </v-layout>
                      </v-flex>


              </v-layout>
                  </v-flex>
            </v-layout>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
              <v-spacer></v-spacer>
          <v-btn  class="white red--text" flat @click="dialog = false">Close</v-btn>
          <v-btn  class="white green--text"  flat @click="dialog = false">Save</v-btn>
        </v-card-actions>
      </v-card>
  </v-layout>
</template>

<script>
import ReportSubscriptionModel from '@/api/service/ReportSubscriptionService';  

import { isArray } from 'util';
  export default {
     props: [
         "selectedData","emailsAvailable"
     ],
    data: () => ({
      dialog: false,
      active:true,
      emailString:"",
      next_date_fmt:"",
      next_date:"",
      next_time:"",
      schedule_interval:"",
      schedule_type:"",
      selectedEmails:{},
      bulkData:{},
      scheduleTypes:[
          "Hours","Days"
        ],
      flags:{
          "addUser":false,
          "removeUser":false,
          "schedule":false,
          "active":false,
          "next_date":false,
          "interval_type":false,
          "next_time":false,
          "interval":false
      }
    }),
   mounted: function() {
       this.next_date_fmt=this.formatDate(this.next_date)
      this.next_time= this.formatTime(this.next_time)
      
        for(var $i=0;$i<this.selected.length;$i++) {
            var $address = this.selected[$i].email_to
            for(var $k=0;$k<$address.length;$k++) {
                if(this.selectedEmails[$address[$k]]) {

                } else {
                    this.selectedEmails[$address[$k]]=true
                }
            }
        }
    },
     watch: {
      next_date (val) {
        this.next_date_fmt = this.formatDate(this.next_date)
      }
    },
    methods: {
        formatDate (date) { 
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      formatTime(time) {
        return '12:00'
      },
       parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
        submit() {

            var $dataOptions ={}

            if(this.flags.removeUser) {
                var $emails  =Object.keys(this.selectedData.emails)
              
                for(var $m=0;$m<$emails.length;$m++)
                {
                    
                    if(!this.selectedData.emails[$emails[$m]])
                    {
                        for(var $i=0;$i<this.selectedData.selectedIds.length;$i++) {
                            if(this.selectedData.selectedIds[$i].email_to.indexOf($emails[$m])>=0) {
                                
                                this.selectedData.selectedIds[$i].email_to.splice(this.selectedData.selectedIds[$i].email_to.indexOf($emails[$m]),1)
                                if(!$dataOptions[this.selectedData.selectedIds[$i].id])
                                {
                                    $dataOptions[this.selectedData.selectedIds[$i].id]={}
                                    $dataOptions[this.selectedData.selectedIds[$i].id].id=this.selectedData.selectedIds[$i].id
                                    $dataOptions[this.selectedData.selectedIds[$i].id].email_to=this.selectedData.selectedIds[$i].email_to    
                                } else {
                                    $dataOptions[this.selectedData.selectedIds[$i].id].email_to=this.selectedData.selectedIds[$i].email_to    
                                }
                            }
                        }
                    }
                    

                }
                
            }
            if(this.flags.addUser) {

                this.emailString.replace(',',';')
                
                var $emailArray = this.emailString.split(';')
                for(var $i=0;$i<this.selectedData.selectedIds.length;$i++) {
                    if(!$dataOptions[this.selectedData.selectedIds[$i].id])
                    {
                        $dataOptions[this.selectedData.selectedIds[$i].id]={}
                        $dataOptions[this.selectedData.selectedIds[$i].id].id=this.selectedData.selectedIds[$i].id
                        $dataOptions[this.selectedData.selectedIds[$i].id].email_to=this.selectedData.selectedIds[$i].email_to
                        $dataOptions[this.selectedData.selectedIds[$i].id].email_to=$dataOptions[this.selectedData.selectedIds[$i].id].email_to.concat($emailArray)
                    }
                    else {
                        $dataOptions[this.selectedData.selectedIds[$i].id].email_to=$dataOptions[this.selectedData.selectedIds[$i].id].email_to.concat($emailArray)
                    }
                }
            }
            if(this.flags.active) {
                for(var $i=0;$i<this.selectedData.selectedIds.length;$i++) {
                    if(!$dataOptions[this.selectedData.selectedIds[$i].id])
                    {
                        $dataOptions[this.selectedData.selectedIds[$i].id]={}
                        $dataOptions[this.selectedData.selectedIds[$i].id].id=this.selectedData.selectedIds[$i].id
                        $dataOptions[this.selectedData.selectedIds[$i].id].active=this.active ? 1 : 0
                    }
                    else {
                         $dataOptions[this.selectedData.selectedIds[$i].id].active=this.active ? 1 : 0
                    }
                }
            }
            if(this.flags.schedule) {
                for(var $i=0;$i<this.selectedData.selectedIds.length;$i++) {
                    if(!$dataOptions[this.selectedData.selectedIds[$i].id])
                    {
                        $dataOptions[this.selectedData.selectedIds[$i].id]={}
                        $dataOptions[this.selectedData.selectedIds[$i].id].id=this.selectedData.selectedIds[$i].id
                  
                            if(this.flags.next_date) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].next_date = this.next_date
                        }
                        if(this.flags.next_time) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].next_time =  this.next_time
                        }
                        
                        if(this.flags.interval) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].schedule_interval = this.schedule_interval
                        }
                        if(this.flags.interval_type) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].schedule_type = this.schedule_type
                        }
                        
                    }
                    else {
                         if(this.flags.next_date) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].next_date = this.next_date
                        }
                        if(this.flags.next_time) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].next_time =  this.next_time
                        }
                        if(this.flags.interval_type) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].schedule_type = this.schedule_type
                        }
                        if(this.flags.interval) {
                            $dataOptions[this.selectedData.selectedIds[$i].id].schedule_interval = this.schedule_interval
                        }
                    }
                }

            }
            //alert(JSON.stringify($dataOptions))
            this.bulkData = $dataOptions
            var $parent = this
            ReportSubscriptionModel.bulkUpdate(this.bulkData)
            .then(response => {
               $parent.$emit('changesApplied')
            }).catch(error => {
                console.log(error)
            }); 

    
    },
    close() {
       this.$emit('changesApplied')  
    }
       
    }
  }
</script>